import Vue from 'vue'
import Vuex from 'vuex'
import questions from './modules/questions';
import products from './modules/products';
import preference from "@/store/config/preference";
import {fetchFirstQuestion} from "@/store/api";
import theme from '@/store/modules/theme';

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        questions,
        products,
        preference,
        theme,
    },

    state: {
        environment: null,
        device: null,
        includingVat: false,
    },

    mutations: {
        setDevice(state, data) {
            state.device = data;
        },
        setEnvironment(state, environment) {
            state.environment = environment;
        },
        setIncludingVat(state, value) {
            state.includingVat = value
        }
    },

    actions: {
        async initialize({commit, dispatch}) {
            const rootEl = document.getElementById('decision-aid');
            const dataset = rootEl.dataset;
            const env = new URLSearchParams(window.location.search).get('environment') ?? dataset.env ?? process.env.VUE_APP_ENVIRONMENT;

            if (!env) {
                throw new Error('No environment set');
            }

            commit('setEnvironment', env);

            const data = await fetchFirstQuestion(env);

            if (data.length === 0) {
                return;
            }

            commit('questions/addQuestions', data);

            const firstQuestionId = data[0].id;

            await dispatch('preference/addQuestionToSteps', firstQuestionId);
        },
        setDevice({commit}, device) {
            commit('setDevice', device);
        },
    },

    getters: {
        getDevice(state) {
            return state.device;
        },
    }
})
